import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { DataSubcodes } from '../../../services/errors/consts'
import { isDataError } from '../../../services/errors/utils'
import { HttpError } from '../../../types/common'
import { LocationList } from '../../../types/locations'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'

const dataApi = DataApi.getInstance()

type MutationParams = {
  uuid: string
  active: boolean
}

export default function useChangePlaceActiveState() {
  const queryClient = useQueryClient()
  const texts = useTranslation().t

  const mutation = useMutation((data: MutationParams) => dataApi.changePlaceActiveState(data.uuid, data.active), {
    onError: (error: AxiosError<HttpError>) => {
      if (isDataError(error, [DataSubcodes.PLACE_NOT_FOUND, DataSubcodes.PLACE_REMOVED])) {
        queryClient.resetQueries([queryNames.getPlaceList])
      }
      showErrorToast(error, texts)
    },
    onSuccess: (_, variables: MutationParams) => {
      const queriesData = queryClient.getQueriesData<LocationList>([queryNames.getPlaceList])
      for (const queryData of queriesData) {
        queryClient.setQueryData(queryData[0], (oldData?: LocationList) => {
          if (!oldData) {
            return oldData
          }
          const newData = [...oldData.places]
          const index = newData.findIndex(p => p.uuid === variables.uuid)
          newData[index] = {
            ...newData[index],
            active: variables.active
          }
          return {
            totalCount: oldData.totalCount,
            places: newData
          }
        })
      }
      toast.success(
        texts(
          variables.active 
          ? 'successes:location_activated' 
          : 'successes:location_deactivated' 
        )
      )
    }
  })

  return mutation
}
